import { apiRequest } from "./apiClient";

export type PumpLookup = {
  id: number;
  pumpName: string;
  zoneId?: number | null;
  zoneName?: string | null;
  walletBalance?: number | null;
};

export function fetchPumpLookups(signal?: AbortSignal) {
  return apiRequest<PumpLookup[]>("/api/pumps/lookups", { signal });
}
